export enum EDrugIndicators {
	INDICATOR_DRUG_SHORTAGE = 1,
	INDICATOR_DRUG_SUPPLY_TENSION = 2,
	INDICATOR_DRUG_PROVISIONING = 3,
}
